import React from 'react';
import Modal from 'react-modal';
import Select, { components } from 'react-select';
import closeIcon from '../../../../assets/images/x_icon_black.svg';

import './index.scss';

const DropdownIndicator = (props) => (
  components.DropdownIndicator && (
    <components.DropdownIndicator {...props}>
      <i className="material-icons custom">arrow_drop_down</i>
    </components.DropdownIndicator>
  )
);

const multiSelectdropdownCustomStyle = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#007bff' : 'white',
    padding: '10px',
    color: state.isSelected ? 'white' : 'black',
    ':hover': {
      backgroundColor: '#f0f0f0',
    },
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: 200, // Set the max height for scrolling
    overflowY: "auto",
  }),
  control: (base) => ({
    ...base,
    border: '1px solid #CFD0D1',
    padding: '6px',
    boxShadow: 'none',
    outline: 'none',
    '&:hover': {
      border: '1px solid #CFD0D1',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0px',
  }),
};

const multiSelectLastdropdownCustomStyle = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#007bff' : 'white',
    padding: '10px',
    color: state.isSelected ? 'white' : 'black',
    ':hover': {
      backgroundColor: '#f0f0f0',
    },
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: 130, // Set the max height for scrolling
    overflowY: "auto",
  }),
  control: (base) => ({
    ...base,
    border: '1px solid #CFD0D1',
    padding: '6px',
    boxShadow: 'none',
    outline: 'none',
    '&:hover': {
      border: '1px solid #CFD0D1',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0px',
  }),
};

const CustomOption = ({ innerProps, label, isSelected }) => (
  <div {...innerProps} className="custom-input-option">
    <input
      className="custom-input-select"
      type="checkbox"
      checked={isSelected}
      readOnly
    />
    <span className="custom-input-option_label">{label}</span>
  </div>
);

const validateName = function(str) {
  const regex = /^[a-zA-Z0-9 ,&-_]{1,100}$/;
  const valstr = regex.test(str) && str.trim() !== '' ? str : '';
  console.log('Validate', str, str.trim(), valstr, regex.test(str));
  return valstr;
};

Modal.setAppElement('#root');

class InstallLayover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedStaff: props.selectedService == 'Edit' ? props.selectedStaff : "",
      selectedResources: props.selectedService == 'Edit' ? props.selectedResources : [],
      selectedTemplates: props.selectedService == 'Edit' ? props.selectedTemplates : [],
      selectedService: props.selectedService
    };
  }

  componentDidMount() {
    const { business } = this.props;
    let staffs = business?.details?.staffs?.map(staff => ({
      label: staff.name,
      value: staff.id
    })) || [];

    const resources = business?.details?.resources?.map(resource => ({
      label: resource.name,
      value: resource.id
    })) || [];

    let templates = business?.details?.locations?.[0]?.location_metadata?.schedule_template_names
      ? JSON.parse(business.details.locations[0].location_metadata.schedule_template_names)
      : [];

    templates = templates.map((template) => ({
        label: template,
        value: template,
      }))
    this.setState(() => ({
      staffs,
      resources,
      templates
    }));
  }

  handleNameChange = (selectedStaff) => {
    this.setState({ selectedStaff }) ;
  }

  handleResourceChange = (selectedResources) => {
    this.setState({ selectedResources });
  };

  handleTemplateChange = (selectedTemplates) => {
    this.setState({ selectedTemplates });
  };

  staffMapping = () => {
    const { selectedStaff, selectedResources, selectedTemplates } = this.state
    const { selectedService } = this.props;

    const data = {
      [selectedStaff.value]:{
        resource_ids: selectedResources.map(res => res.value),
        schedule_template_names: selectedTemplates.map(res => res.value),
      }
    }
    this.props.updatStaffMap(data, selectedService);
  }
  
  render() {
    const { modelopen, closeStaffModal } = this.props;
    const { staffs, resources, templates, selectedStaff, selectedResources, selectedTemplates, selectedService } = this.state;

    return (
      <Modal
        isOpen={modelopen}
        onRequestClose={closeStaffModal}
        className="Modal"
        overlayClassName="Overlay"
      >
        <div className="pc-modal-header">
          <div className="title">{selectedService} Staff Map</div>
          <button className="modal-close" onClick={closeStaffModal}>
            <img src={closeIcon} alt="Close" />
          </button>
          <div className="input">
            <label className="label">Select Staff</label>
            <Select
              isMulti={false}
              options={staffs}
              value={selectedStaff}
              onChange={this.handleNameChange}
              components={{ DropdownIndicator, IndicatorSeparator: () => null }}
              styles={multiSelectdropdownCustomStyle}
            />
          </div>
          <div className="input">
            <label className="label">Select Resources</label>
            <Select
              isMulti
              options={resources}
              value={selectedResources}
              onChange={this.handleResourceChange}
              components={{ DropdownIndicator, IndicatorSeparator: () => null }}
              styles={multiSelectdropdownCustomStyle}
            />
          </div>
          <div className="input">
            <label className="label">Select Templates</label>
            <Select
              isMulti
              options={templates}
              value={selectedTemplates}
              onChange={this.handleTemplateChange}
              components={{ DropdownIndicator, IndicatorSeparator: () => null }}
              styles={multiSelectLastdropdownCustomStyle}
            />
          </div>
          <p className='note'>Please click the <strong>SAVE </strong> button after all your updates to persist the changes</p>
          <div className="staff_mapping_actions">
            <button onClick={this.staffMapping} className="btn btn--primary btn--lg">
              {selectedService === 'Edit' ? 'UPDATE' : 'ADD'}
            </button>
            <button className="btn btn--secondary btn--lg" onClick={closeStaffModal}>
              CANCEL
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default InstallLayover;
